// import { 
//     apiRequest,
//     standarKompetensiUpdate,
//     standarKompetensiDetailStankom,
//     kompetensiList,
//     kompetensiLevel
//  } from '../../../../../services/adapters/base'
import { 
    apiRequest,
    standarKompetensiUpdate,
    standarKompetensiDetailStankom,
    kompetensiList,
    kompetensiLevel
 } from '../../../../../services/adapters/Assesment/assesmentService'


class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest('post', standarKompetensiUpdate, {
            body: query
        }, true)
    }

    fetchDetailStankom = async (query, cancelToken) => {
        return await apiRequest('get', standarKompetensiDetailStankom, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchKompetensiList = async (query, cancelToken) => {
        return await apiRequest('get', kompetensiList, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
    fetchKompetensiLevel = async (query, cancelToken) => {
        return await apiRequest('get', kompetensiLevel, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }
 
}

export default UpdateRepository
